import { render, staticRenderFns } from "./FeedbackStep.vue?vue&type=template&id=6278d60d&scoped=true&"
import script from "./FeedbackStep.vue?vue&type=script&lang=js&"
export * from "./FeedbackStep.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackStep.vue?vue&type=style&index=0&id=6278d60d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278d60d",
  null
  
)

export default component.exports